module.exports = __webpack_public_path__ + "static/docker-e4517c90a2c58ee4a02d56da297b24f3.png";